<basic-input [control]="control" [fieldType]="fieldType" [mode]="mode" [icon]="icon">
  <div class="tw-relative dropdown tw-box-border">
    <!-- Less than or equal to 8 selections -->
    @if (!isDropdown && !isCountryField) {
    <ng-container>
      <div
        class="tw-box-border tw-rounded-lg tw-px-3 tw-flex tw-gap-2 tw-items-center tw-border tw-min-h-[58px]"
        [class.auto-change-highlight]="autoChangeHighlight"
        [ngClass]="{
          'tw-border-gray-300 dark:tw-border-gray-600': (control.untouched && !control.disabled) || control.disabled,
          'tw-border-green-600': control.valid && control.touched && !control.disabled,
          'tw-border-red-600': !control.valid && control.touched && !control.disabled,
          'tw-py-5': counter,
          'tw-py-[13px]': !counter,
          '!tw-border-none tw-rounded-[4px] !tw-mb-1 !tw-py-0 !tw-text-base inline-input': mode === BasicInputMode.INLINE,
          '!tw-bg-red-200 dark:!tw-bg-red-800': mode === BasicInputMode.INLINE && control.invalid && control.touched,
          'hover:!tw-bg-gray-100 dark:hover:!tw-bg-gray-700': mode === BasicInputMode.INLINE && !(control.invalid && control.touched),
          '!tw-bg-gray-200 dark:!tw-bg-gray-600': mode === BasicInputMode.INLINE && isFocused && !(control.invalid && control.touched),
          'tw-rounded-lg': mode !== BasicInputMode.INLINE
        }"
      >
        @if (icon) {
        <span
          [innerHTML]="sanitizeSVG(icon)"
          class="tw-flex tw-items-center"
          [ngClass]="{
            'fill-icon': iconType === 'fill',
            'stroke-icon': iconType === 'stroke',
            valid: control.valid && control.touched,
            invalid: !control.valid && control.touched,
            disabled: control.disabled
          }"
        ></span>
        }
        <div class="tw-flex tw-flex-wrap tw-flex-grow tw-gap-2.5">
          @for (selection of values;track $index; let i = $index) {
          <span
            tabindex="0"
            class="tw-group tw-inline-flex tw-gap-1 tw-items-center tw-cursor-pointer tw-select-none tw-bg-gray-100 dark:tw-bg-gray-700 tw-transition tw-duration-100 tw-rounded-md"
            (click)="selectValue(selection)"
            (keydown.enter)="selectValue(selection); $event.preventDefault()"
            (keydown.space)="selectValue(selection); $event.preventDefault()"
            [ngxTippy]="selection?.tooltip || null"
            [tippyProps]="optionChipTippyProps"
            [class.chip-selected]="isSelected(selection)"
            [ngClass]="{
							'tw-text-gray-900 dark:tw-text-gray-300 hover:tw-bg-blue-200': !isSelected(selection) && !selection?.disabled,
							'!tw-bg-blue-600 hover:!tw-bg-blue-600 tw-text-white hover:!tw-text-white': isSelected(selection),
							'tw-px-2.5 tw-py-px': selection?.[key] || selection,
							'!tw-py-[5px]': !selection?.[key] || selection,
							'tw-opacity-50': !!selection?.disabled,
							'tw-cursor-auto': control.disabled || !!selection?.disabled,
							'tw-pointer-events-none': (control.disabled || !!selection?.disabled) && !selection?.tooltip
						}"
            [attr.data-tooltip-target]="i"
            [attr.data-tooltip-placement]="tooltipPlacement"
          >
            @if(showTooltip){
            <div
              [attr.id]="i"
              role="tooltip"
              class="tw-absolute tw-z-[100] tw-invisible tw-inline-block tw-px-3 tw-py-[6.5px] tw-text-xs tw-font-normal tw-leading-[18px] tw-text-white tw-bg-gray-800 tw-rounded-lg tw-shadow-sm tw-opacity-0 tooltip"
            >
              {{ tooltipValues[i] || selection?.tooltip }}
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            } @if (selection?.icon) {
            <span class="icon" [innerHTML]="sanitizeSVG(selection?.icon)" [ngClass]="{ selected: isSelected(selection) }"></span>
            } @if (selection?.[key] || selection) {
            <span
              class="tw-text-xs tw-font-medium tw-leading-[18px] tw-h-fit"
              [ngClass]="{
                'tw-mb-0.5': selection?.icon
              }"
            >
              {{ selection?.[key] || selection }}
            </span>
            } @if(clear){
            <button
              type="button"
              class="tw-group close-btn tw-inline-flex tw-items-center tw-p-1 tw-transition tw-duration-100 tw-rounded-full"
              (click)="removeValue(selection, $event)"
            >
              <svg
                class="tw-w-2 tw-h-2 tw-stroke-gray-900"
                [ngClass]="{
                  'tw-stroke-gray-900': !isSelected(selection),
                  'tw-stroke-white hover:tw-stroke-white': isSelected(selection)
                }"
                viewBox="0 0 14 14"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
              </svg>
            </button>
            }
          </span>
          }
        </div>
        @if (clearAll) {
        <button
          tabindex="-1"
          type="button"
          class="tw-group stroke-icon tw-inline-flex tw-items-center tw-p-1.5 tw-transition tw-duration-100 tw-rounded-full"
          (click)="clearAllValues()"
          [ngClass]="{
            valid: control.valid && control.touched,
            invalid: !control.valid && control.touched,
            'tw-cursor-auto tw-pointer-events-none disabled': control.disabled
          }"
        >
          <svg class="tw-w-2.5 tw-h-2.5 tw-stroke-gray-500 group-hover:tw-stroke-gray-400" viewBox="0 0 14 14">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
          </svg>
        </button>
        }
      </div>
      @if (counter) {
      <span class="tw-absolute tw-bottom-1 tw-end-3 tw-select-none tw-font-normal tw-leading-[18px] tw-text-xs tw-text-gray-400">
        {{ counterLabel }}
      </span>
      } @if(mode !== BasicInputMode.INLINE) {
      <label
        class="tw-z-10 tw-scale-75 tw-absolute tw-text-sm tw-font-medium tw-leading-[18px] tw-select-none tw-transform -tw-translate-y-4 tw-top-[6px] tw-origin-[0] tw-bg-white dark:tw-bg-gray-800 tw-px-1 tw-start-2"
        [ngClass]="{
          'tw-text-gray-400': control.disabled,
          'tw-text-gray-700 dark:tw-text-gray-400': control.untouched && !control.disabled,
          'tw-text-green-600': control.valid && control.touched && !control.disabled,
          'tw-text-red-600': !control.valid && control.touched && !control.disabled
        }"
      >
        {{ label }}
        @if(required){<span class="tw-text-red-500">*</span>}
      </label>
      }
    </ng-container>
    } @else{
    <ng-container>
      <app-dropdown
        #dropdownRef
        [maxHeightInPX]="dropdownMaxHeightInPX"
        (click)="setDropdownOptions()"
        [isField]="true"
        [heightInPX]="dropdownHeightInPX"
        [isSingleSelect]="isSingleSelect"
        [dropdownOptions]="dropdownOptions"
        [hasSearchQuery]="hasSearchQuery"
        [forceHide]="forceHideDropdown"
        [optionNoData]="optionNoData"
        (optionClicked)="optionClicked($event)"
        (dropdownClosed)="onDropdownClosed()"
        (dropdownOpened)="onDropdownOpened()"
      >
        <div
          #container
          class="tw-box-border dropdown__box tw-group tw-w-full tw-flex tw-items-center tw-px-3 tw-rounded-lg tw-bg-transparent dark:tw-bg-gray-800 tw-border focus:tw-outline-none focus:tw-ring-0 focus-within:tw-outline-none focus-within:tw-ring-0 hover:tw-border-blue-700 dark:hover:tw-border-blue-600 focus:tw-border-blue-600 dark:focus:tw-border-blue-500 tw-overflow-hidden"
          [class.auto-change-highlight]="autoChangeHighlight"
          [ngClass]="{
          'tw-border-gray-300 dark:tw-border-gray-600':
            (control.untouched && !control.value) ||
            (control.untouched && control.value) ||
            control.disabled || (dropdown && enableSearch),
          'hover:tw-border-blue-600': !control.disabled,
          '!tw-border-green-600 hover:!tw-border-green-700 dark:!tw-border-green-500':
            control.valid &&( control.touched || control.dirty) && !dropdown && !control.disabled,
          '!tw-border-red-600 hover:!tw-border-red-700 dark:!tw-border-red-500':
            !control.valid && control.touched && !control.disabled,
          'tw-border-blue-600': dropdown && !enableSearch,
          'tw-cursor-text': enableSearch && !control.disabled,
          'tw-cursor-pointer': !enableSearch && !control.disabled,
          'tw-cursor-auto': control.disabled,
          'tw-py-5': counter,
          'tw-border-2': isFocused,
          'tw-border-2 -tw-m-px': isFocused && !isSingleSelect && enableSearch,
          'tw-py-[10px] tw-gap-2.5 ':
            !counter && !isCountryField && !isBasicDropdownValue && isSingleSelect && !enableSearch,
          'tw-py-[14px]': !isSingleSelect && hasValueForLabel,
          'tw-py-[18px]': !isSingleSelect && !hasValueForLabel,
          'tw-py-2': isCountryField || isBasicDropdownValue,
          '!tw-border-none tw-rounded-[4px] !tw-mb-1 !tw-py-0 !tw-text-base inline-input': mode === BasicInputMode.INLINE,
          '!tw-bg-red-200 dark:!tw-bg-red-800': mode === BasicInputMode.INLINE && control.invalid && control.touched,
          'hover:!tw-bg-gray-100 dark:hover:!tw-bg-gray-700': mode === BasicInputMode.INLINE && !(control.invalid && control.touched),
          '!tw-bg-gray-200 dark:!tw-bg-gray-600': mode === BasicInputMode.INLINE && isFocused && !(control.invalid && control.touched),
          'tw-rounded-lg': mode !== BasicInputMode.INLINE,
          'tw-h-9 lg:tw-h-[26px] !tw-px-1': mode === BasicInputMode.INLINE,
          'tw-h-[58px]': mode !== BasicInputMode.INLINE && isSingleSelect,
          'tw-h-auto tw-min-h-[58px]': !isSingleSelect,
          '!tw-overflow-visible': autoChangeHighlight,
        }"
          (click)="onDropdownBoxClick($event)"
        >
          @if (icon && !values[selectedValues[0]]?.flag) {
          <span
            [innerHTML]="sanitizeSVG(icon)"
            class="tw-cursor-auto"
            [ngClass]="{
              'fill-icon': iconType === 'fill',
              'stroke-icon': iconType === 'stroke',
              focused: dropdown,
              valid: control.valid && control.touched && !dropdown,
              invalid: !control.valid && control.touched && !dropdown,
              disabled: control.disabled
            }"
          ></span>
          }
          <div
            #selectedValuesContainer
            class="tw-flex tw-flex-wrap tw-items-center tw-flex-grow tw-py-2 tw-gap-2.5"
            [class.multi-select-chips]="!isSingleSelect"
            [ngClass]="{
              '!tw-py-0': !isSingleSelect,
              'tw-ms-2': !isCountryField && !isBasicDropdownValue && isSingleSelect,
              '!tw-px-2.5': mode === BasicInputMode.INLINE,
              '!tw-px-0': !isSingleSelect,
              '!tw-px-1': icon
            }"
          >
            @for (value of selectedValues; track $index; let i = $index) {
            <span
              class="tw-group tw-inline-flex tw-gap-2 tw-items-center tw-select-none tw-transition tw-duration-100 tw-text-gray-500 dark:tw-text-gray-400 tw-flex-shrink-0"
              (click)="selectValue(values[value]); $event.stopPropagation()"
              [ngxTippy]="!isSingleSelect ? chipTooltip(value) : null"
              [tippyProps]="chipTippyProps"
              [ngClass]="{
							'tw-px-2.5 tw-py-px': values[value]?.[key] || values[value],
							'tw-px-3 tw-h-7':
								values[value]?.[key] || (values[value] && isCountryField) || isBasicDropdownValue,
							'tw-p-[5px]': !values[value]?.[key],
							'tw-cursor-pointer': !control.disabled,
							'tw-cursor-auto tw-pointer-events-none': control.disabled,
							'hover:tw-bg-gray-200 focus:tw-bg-gray-100 tw-rounded-[4px] focus:tw-border focus:tw-border-blue-600 tw-bg-gray-100':
								!isCountryField && !isBasicDropdownValue && !values[value]?.chipMuted,
							'tw-rounded-[4px] tw-bg-gray-200 tw-text-gray-500': !!values[value]?.chipMuted,
							'tw-hidden': isBasicDropdownValue
						}"
              [attr.data-tooltip-target]="i"
              [attr.data-tooltip-placement]="tooltipPlacement"
            >
              @if (showTooltip) {
              <div
                [attr.id]="i"
                role="tooltip"
                class="tw-absolute tw-z-[100] tw-invisible tw-inline-block tw-px-3 tw-py-[6.5px] tw-text-xs tw-font-notmal tw-leading-[18px] tw-text-white tw-bg-gray-800 tw-rounded-lg tw-shadow-sm tw-opacity-0 tooltip"
              >
                {{ tooltipValues[i] || values[value]?.tooltip }}
                <div class="tooltip-arrow" data-popper-arrow></div>
              </div>
              } @if (values[value]?.icon) {
              <span class="icon" [innerHTML]="sanitizeSVG(values[value]?.icon)" [ngClass]="{ selected: !isSelected(values[value]) }"></span>
              } @if (values[value]?.flag && control.value) {
              <span class="flag-container tw-absolute tw-top-5 tw-transform" [ngClass]="{ selected: !isSelected(values[value]) }">
                <img [src]="values[value]?.flag" [alt]="values[value].name" class="flag tw-rounded-full tw-object-cover" />
              </span>
              } @if ((values[value]?.[key] || values[value]) && !isCountryField && !isBasicDropdownValue) {
              <span
                class="tw-font-medium tw-leading-[18px] tw-mb-px tw-h-fit tw-text-xs lg:tw-max-w-[160px] lg:tw-truncate tw-overflow-hidden"
                [ngClass]="values[value]?.chipMuted ? 'tw-text-gray-500' : 'tw-text-gray-900'"
                [ngxTippy]="showTooltip ? values[value]?.[key] || values[value] : null"
              >
                {{ values[value]?.[key] || values[value] }}
              </span>
              } @if (clear) {
              <button
                type="button"
                class="close-btn tw-inline-flex tw-items-center tw-pl-2 tw-transition tw-duration-100 tw-rounded-full"
                (click)="removeValue(values[value], $event)"
              >
                <svg class="tw-w-2 tw-h-2" [ngClass]="values[value]?.chipMuted ? 'tw-stroke-gray-500' : 'tw-stroke-gray-900'" viewBox="0 0 14 14">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                </svg>
              </button>
              }
            </span>
            }
            <div
              class="tw-outline-none tw-ring-0 focus-within:tw-outline-none focus-within:tw-ring-0"
              [ngClass]="{
              'tw-w-full': !isCountryField && isSingleSelect,
              'tw-flex-1 tw-min-w-[2ch]': !isSingleSelect && enableSearch,
              'tw-min-w-[280px]': isCountryField && selectedValue && selectedValue.length > 20,
              'tw-hidden': !isSingleSelect && !enableSearch,
               }"
            >
              <input
                #selectInput
                [autocomplete]="autocomplete"
                type="text"
                [id]="id"
                [attr.title]="isBasicDropdownValue && inputDisplayValue ? inputDisplayValue : null"
                [style.width]="!isSingleSelect && enableSearch ? searchInputWidth : null"
                [style.minWidth]="!isSingleSelect && enableSearch ? '2ch' : null"
                [style.maxWidth]="!isSingleSelect && enableSearch ? '100%' : null"
                class="tw-border-none tw-h-5 tw-text-sm dark:tw-text-white tw-font-medium tw-leading-[21px] tw-peer tw-bg-white dark:tw-bg-gray-800 tw-outline-none focus:tw-outline-none focus:tw-ring-0"
                [style.caretColor]="isCountryField || isBasicDropdownValue || enableSearch ? 'auto' : 'transparent'"
                [placeholder]="placeholder"
                (focus)="showDropdown()"
                (input)="filterValues($event)"
                (keydown)="onInputKeydown($event)"
                (blur)="onBlur()"
                [value]="inputDisplayValue"
                [disabled]="control.disabled"
                [ngClass]="{
                  'tw-w-full tw-min-w-fit tw-flex-grow': isSingleSelect || !enableSearch,
                  'tw-cursor-text': enableSearch && !control.disabled,
                  'tw-cursor-pointer': !enableSearch && !control.disabled,
                  'placeholder:!tw-text-transparent':
                    (!hasValueForLabel && !dropdown && mode !== BasicInputMode.INLINE) ||
                    (control.touched && control.dirty && !hasValueForLabel && !control.errors) ||
                    hasValueForLabel,
                  'placeholder:!tw-text-gray-500 dark:placeholder:!tw-text-gray-300': hasValueForLabel || (!hasValueForLabel && control.touched && !control.validator),
                  'tw-cursor-auto': control.disabled,
                  '!tw-px-0': (isCountryField || isCityField) && hasValueForLabel,
                  'tw-h-[41px]': isBasicDropdownValue && mode !== BasicInputMode.INLINE,
                  'tw-truncate': isBasicDropdownValue && hasValueForLabel && !hasSearchQuery,
                  'tw-h-9 lg:tw-h-[26px] !tw-px-0': mode === BasicInputMode.INLINE,
                  'placeholder:!tw-opacity-100 !tw-text-base placeholder:tw-text-gray-500': mode === BasicInputMode.INLINE,
                  '!tw-bg-red-200 dark:!tw-bg-red-800': mode === BasicInputMode.INLINE && control.invalid && control.touched,
                  'group-hover:!tw-bg-gray-100 dark:group-hover:!tw-bg-gray-700': mode === BasicInputMode.INLINE && !(control.invalid && control.touched),
                  '!tw-bg-gray-200 dark:!tw-bg-gray-600': mode === BasicInputMode.INLINE && isFocused && !(control.invalid && control.touched),
                  '!tw-border-red-600 dark:!tw-border-red-500 hover:!tw-border-red-700': control.invalid && !control.disabled && control.touched,
                  '!tw-border-green-600 dark:!tw-border-green-500 hover:!tw-border-green-700':
                    mode !== BasicInputMode.INLINE && control.valid && !control.disabled && hasValueForLabel && control.touched
                }"
              />
            </div>
          </div>
          @if (clearAll) {
          <button
            tabindex="-1"
            type="button"
            class="tw-group stroke-icon tw-items-center tw-p-1.5 tw-transition tw-duration-100 tw-rounded-full tw-ml-auto"
            (click)="clearAllValues(); $event.stopPropagation()"
            [ngClass]="{
              focused: dropdown,
              valid: control.valid && control.touched && !dropdown,
              invalid: !control.valid && control.touched && !dropdown,
              'tw-cursor-auto tw-pointer-events-none disabled': control.disabled,
              'tw-hidden': (!hasValueForLabel && !dropdown) || (isCityField && mode === BasicInputMode.INLINE),
              'tw-inline-flex': hasValueForLabel || dropdown
            }"
          >
            <svg class="tw-w-2.5 tw-h-2.5 clear tw-stroke-gray-500 group-hover:tw-stroke-gray-400" viewBox="0 0 14 14">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
          </button>
          } @if(mode !== BasicInputMode.INLINE) {
          <label
            [for]="id"
            class="tw-z-10 tw-box-border tw-absolute tw-text-sm tw-font-medium tw-leading-[21px] tw-select-none tw-transition-all tw-duration-300 tw-ease-out tw-transform tw-origin-[0] tw-bg-white dark:tw-bg-gray-800 tw-px-1"
            [ngClass]="{
              'tw-text-gray-400': control.disabled,
              'tw-text-gray-500 dark:tw-text-gray-400': !control.dirty && !hasValueForLabel && !dropdown,
              'tw-text-gray-700 dark:tw-text-gray-400': control.untouched && hasValueForLabel,
              '!tw-text-green-600': control.valid && !dropdown && (control.touched || control.dirty) && !control.disabled,
              '!tw-text-red-600': !control.valid && control.touched && !control.disabled,
              'tw-text-blue-800': dropdown && !(control.invalid && control.touched && !control.disabled),
              'tw-start-9': icon && !hasValueForLabel && !dropdown,
              'tw-start-2': icon && (hasValueForLabel || dropdown),
              'tw-top-1 tw-scale-75 -tw-translate-y-4': hasValueForLabel || dropdown,
              'tw-top-1/2 -tw-translate-y-1/2 tw-scale-100': !hasValueForLabel && !dropdown,
              'tw-cursor-text': enableSearch && !control.disabled,
              'tw-cursor-pointer': !enableSearch && !control.disabled,
              'tw-cursor-auto': control.disabled
            }"
          >
            {{ label }}
            @if (required) {
            <span class="tw-text-red-500">*</span>
            }
          </label>
          } @if (counter) {
          <span class="tw-absolute tw-bottom-1 tw-end-3 tw-select-none tw-font-normal tw-leading-[18px] tw-text-xs tw-text-gray-400">
            {{ counterLabel }}
          </span>
          }
        </div>
      </app-dropdown>
    </ng-container>
    }
  </div>
</basic-input>
